import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PageContainer, PageHeader } from "@fleet/ui";
import { MenuManager } from "@/features/menu/components/menu-manager";
import { RestaurantGate } from "@/features/pos/components/restaurant-gate";
import { useActiveContext } from "@/features/pos/hooks/use-active-context";
import { useI18n } from "@/providers/i18n-provider";

function MenuPage() {
  const { t } = useI18n();
  const ctx = useActiveContext();
  return (
    <PageContainer maxWidth="3xl">
      <PageHeader title={t(msg`Menu`)} />
      <RestaurantGate ctx={ctx}>
        {(c) => <MenuManager org={c.org} branch={c.branch} />}
      </RestaurantGate>
    </PageContainer>
  );
}

export const menuRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/menu",
  component: MenuPage,
});
